export default "__VITE_ASSET__C82lXDhm__"